import {
    ColorSchemeScript,
    MantineProvider,
} from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { NuqsAdapter } from 'nuqs/adapters/react'
import './i18n'

import { createTheme, colorsTuple, DEFAULT_THEME } from '@mantine/core';
import '@mantine/core/styles.css';
import '@mantine/carousel/styles.css';
import '@mantine/dropzone/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';
import 'mantine-react-table/styles.css';
import '@mantine/tiptap/styles.css';
import './assets/css/styles.css';
import './assets/css/colors.css';
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

const theme = createTheme({
    fontFamily: `Manrope, SF Pro Display, ${DEFAULT_THEME.fontFamily}`,
    colors: {
        'smartico-blue': colorsTuple('#3c64a2'),
        'smartico-blue-accent': colorsTuple('#506195'),
        'smartico-black': colorsTuple('#212529'),
        'smartico-grey': colorsTuple('#B5B5B5'),
        'smartico-green': colorsTuple('#127c4e'),
        'smartico-purple': colorsTuple('#800080'),
        'smartico-pink': ["#ffe9f6", "#ffd1e6", "#faa1c9", "#f66dac", "#f34392", "#f12983", "#D00B65", "#d80b69", "#c1005d", "#aa0050"],
        'figma-grey': ["#FAFAFA", "#EFEFEF", "#EDEDED", "#EBEBEB", "#787878", "#565656", "#353535", "#343434", "#333333", "#141B34"],
        'figma-green': colorsTuple('#00922F'),
        'sma-dark': Array.from({ length: 10 }, (_, i) => `var(--sma-color-dark-${i})`),
        // Mantine reads dark body from dark-7 and surfaces from dark-6, so the ramp is
        // offset by one to land on the design's #1F1F1F page and #242424 cards.
        'dark': Array.from({ length: 10 }, (_, i) => `var(--sma-color-black-${Math.min(i + 1, 9)})`),
        'sma-gray': Array.from({ length: 10 }, (_, i) => `var(--sma-color-gray-${i})`),
        'blue': Array.from({ length: 10 }, (_, i) => `var(--sma-color-blue-${i})`),
        'red': Array.from({ length: 10 }, (_, i) => `var(--sma-color-red-${i})`),
        'green': Array.from({ length: 10 }, (_, i) => `var(--sma-color-green-${i})`),
        'yellow': Array.from({ length: 10 }, (_, i) => `var(--sma-color-yellow-${i})`),
        'orange': Array.from({ length: 10 }, (_, i) => `var(--sma-color-orange-${i})`),
        'pink': Array.from({ length: 10 }, (_, i) => `var(--sma-color-pink-${i})`),
    },
    primaryColor: "pink",
    defaultRadius: "md",
});

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
})

export default function ({ children }) {
    return (
        <>
            <NuqsAdapter>
                <QueryClientProvider client={queryClient}>
                    <DndProvider backend={HTML5Backend}>
                        {/* The product is designed light-only (no dark palette in colors.css),
                            so the scheme is pinned instead of following the OS preference. */}
                        <ColorSchemeScript forceColorScheme="light" />
                        <MantineProvider
                            theme={theme}
                            defaultColorScheme="light"
                            forceColorScheme="light"
                        >
                            <Notifications />
                            <ModalsProvider modalProps={{ radius: 'md' }}>{children}</ModalsProvider>
                        </MantineProvider>
                    </DndProvider>
                </QueryClientProvider>
            </NuqsAdapter>
        </>
    );
}
